import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AlertModalComponent }   from './modal.alert.component';
import { CaptureModalComponent } from './modal.capture.component';
import { ModalService }          from './modal.service';
import { NoteModalComponent }    from './modal.note.component';
import { SharedModule }          from '../shared/shared.module';

@NgModule({
  declarations: [
    AlertModalComponent,
    CaptureModalComponent,
    NoteModalComponent
  ],
  entryComponents: [
    AlertModalComponent,
    CaptureModalComponent,
    NoteModalComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ModalService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class ModalsModule {}
